export default defineNuxtRouteMiddleware((to) => {
  // Don't redirect if already heading to sign-in page to prevent loops
  if (to.path === '/auth/sign-in') {
    return
  }

  const { $pinia } = useNuxtApp();
  const store = useAuthStore($pinia)
  const { authenticated } = storeToRefs(store)

  // Handle protected routes
  if (to?.meta?.requiresAuth && !authenticated.value) {
    abortNavigation()
    return navigateTo('/auth/sign-in')
  }

  // Handle authenticated users trying to access auth pages
  if (authenticated.value && to?.name === 'auth-slug') {
    return navigateTo('/')
  }
})